import React from "react";
import Layout from "../components/Layout";
import GMS from "../components/_GMS";

const GMSPage = (props:any) => {
    return (
    <Layout>
        <GMS />
    </Layout>
    )
}

export default GMSPage